// import Main from '@/view/main'

export default {
  path: 'business',
  meta: {
    title: '业务审核'
  },
  component: () => import('@/components/parent-view'),
  name: 'business',
  children: [
    {
      path: 'review',
      meta: {
        title: '业务审核'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '业务审核列表'
          },
          name: 'om-business-list',
          component: () => import('@/view/business/index.vue')
        },
        {
          path: 'detail',
          meta: {
            title: '查看详情'
          },
          name: 'om-business-detail',
          component: () => import('@/view/business/detail.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/business.js